export const KEY = 'squire-auth-token';
export const TTL = 30;
